import { inject, Injectable } from '@angular/core';
import { NavItemLinks } from '@com-delta-idp/mnx-sitewide-header-ui';
import { HeaderFooterMachCoreContentService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject } from 'rxjs';
import { NavigationLinksAdapterService } from '../../adapters/navigation-links/navigation-links-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationLinksFacadeService {
  adapter = inject(NavigationLinksAdapterService);
  headerFooterContent = inject(HeaderFooterMachCoreContentService);
  navigationLinksDetails$ = new BehaviorSubject<NavItemLinks>(
    {} as NavItemLinks
  );

  init(): void {
    this.headerFooterContent
      .getHeaderFooterMachCoreContent$()
      .subscribe((content) => {
        this.navigationLinksDetails$.next(this.adapter.getContent(content));
      });
  }
}
